"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
/**
 * A react hook to hold the previous value of a reference between renders
 */
const usePrevious = newValue => {
  const prevValue = (0, _react.useRef)();

  // Update reference on value change
  (0, _react.useEffect)(() => {
    prevValue.current = newValue;
  });

  // Return current reference
  return prevValue.current;
};
var _default = exports.default = usePrevious;